import type { AIAssistantClientSkill } from 'balus-common';
import YAMLDefault from 'yaml';
import type * as YAMLModule from 'yaml';

const YAML = YAMLDefault as typeof YAMLModule;

export function buildSkillDefinitionText(skill: AIAssistantClientSkill): string {
  const frontmatter = YAML.stringify({
    enabled: skill.enabled,
    name: skill.name,
    description: skill.description,
    triggers: skill.triggers,
    whenToUse: skill.whenToUse,
    argumentHint: skill.argumentHint,
  }).trimEnd();

  return `---\n${frontmatter}\n---\n\n${skill.prompt}`;
}
